// pipelines.js

function getPipelineHolidays(emp) {
  return [
    {
      $match: {
        $expr: {
          $and: [
            // ✅ ACL stays required
            { $in: ["*", "$acl.read"] },

            // ✅ Either selectAll is true OR match org structure
            {
              $or: [
                // 1) selectAll holidays (global)
                { $eq: ["$selectAll", true] },

                // 2) org-scoped holidays
                {
                  $and: [
                    {
                      $or: [
                        { $eq: [{ $size: { $ifNull: ["$regions", []] } }, 0] },
                        { $in: [emp.region, "$regions"] },
                      ],
                    },
                    {
                      $or: [
                        { $eq: [{ $size: { $ifNull: ["$offices", []] } }, 0] },
                        { $in: [emp.office, "$offices"] },
                      ],
                    },
                    {
                      $or: [
                        {
                          $eq: [{ $size: { $ifNull: ["$divisions", []] } }, 0],
                        },
                        { $in: [emp.division, "$divisions"] },
                      ],
                    },
                    {
                      $or: [
                        { $eq: [{ $size: { $ifNull: ["$units", []] } }, 0] },
                        { $in: [emp.unit, "$units"] },
                      ],
                    },
                    // Optional: plantilla/cluster filter
                    // {
                    //   $or: [
                    //     { $eq: [{ $size: { $ifNull: ["$plantilla", []] } }, 0] },
                    //     { $in: [emp.cluster, "$plantilla"] },
                    //   ],
                    // },
                  ],
                },
              ],
            },
          ],
        },
      },
    },
    { $sort: { date: -1 } },
    {
      $project: {
        name: 1,
        type: 1,
        date: 1,
        from: 1,
        to: 1,
        dateFrom: 1,
        dateTo: 1,
      },
    },
  ];
}

function getPipelineByEmployees(employees) {
  const regionSet = new Set();
  const officeSet = new Set();
  const divisionSet = new Set();
  const unitSet = new Set();
  const plantillaSet = new Set();

  for (const emp of employees) {
    if (emp.region) regionSet.add(emp.region);
    if (emp.office) officeSet.add(emp.office);
    if (emp.division) divisionSet.add(emp.division);
    if (emp.unit) unitSet.add(emp.unit);
    if (emp.cluster) plantillaSet.add(emp.cluster);
  }

  const regions = [...regionSet];
  const offices = [...officeSet];
  const divisions = [...divisionSet];
  const units = [...unitSet];
  const plantilla = [...plantillaSet];

  return [
    {
      $match: {
        $expr: {
          $and: [
            {
              $in: ["*", "$acl.read"],
            },
            {
              $or: [
                { $eq: [{ $size: { $ifNull: ["$regions", []] } }, 0] },
                { $setIsSubset: [regions, "$regions"] },
              ],
            },
            {
              $or: [
                { $eq: [{ $size: { $ifNull: ["$offices", []] } }, 0] },
                { $setIsSubset: [offices, "$offices"] },
              ],
            },
            {
              $or: [
                { $eq: [{ $size: { $ifNull: ["$divisions", []] } }, 0] },
                { $setIsSubset: [divisions, "$divisions"] },
              ],
            },
            {
              $or: [
                { $eq: [{ $size: { $ifNull: ["$units", []] } }, 0] },
                { $setIsSubset: [units, "$units"] },
              ],
            },
            {
              $or: [
                { $eq: [{ $size: { $ifNull: ["$plantilla", []] } }, 0] },
                { $setIsSubset: [plantilla, "$plantilla"] },
              ],
            },
          ],
        },
      },
    },
    { $sort: { date: -1 } },
    {
      $project: {
        name: 1,
        type: 1,
        date: 1,
        from: 1,
        to: 1,
        dateFrom: 1,
        dateTo: 1,
      },
    },
  ];
}

function getPipelineSuspension(emp) {
  const pipeline = getPipelineHolidays(emp);
  pipeline[0].$match.$expr.$and.push({ $eq: ["$status", "active"] });
  return pipeline;
}

function getPipelineHolidaysManualTime(emp, date) {
  const pipeline = getPipelineHolidays(emp);
  pipeline[0].$match.$expr.$and.push({
    $eq: [{ $dateFromString: { dateString: date } }, "$date"],
  });
  return pipeline;
}

function getPipelineSuspensionManualTime(emp, date) {
  const pipeline = getPipelineHolidays(emp);
  pipeline[0].$match.$expr.$and.push({ $eq: ["$status", "active"] });
  pipeline[0].$match.$expr.$and.push({
    $gte: [{ $dateFromString: { dateString: date } }, "$from"],
  });
  pipeline[0].$match.$expr.$and.push({
    $lte: [{ $dateFromString: { dateString: date } }, "$to"],
  });
  return pipeline;
}

function getPipelineHolidaysWithinRange(emp, dateRange) {
  const pipeline = getPipelineByEmployees(emp);

  if (!Array.isArray(dateRange) || !dateRange.length) return pipeline;

  const dateConditions = dateRange
    .filter((d) => d && d.startDate && d.endDate)
    .map(({ startDate, endDate }) => {
      const isoStart = parseDateToISO(startDate);
      const isoEnd = parseDateToISO(endDate);

      if (!isoStart || !isoEnd) return null;

      return {
        $and: [
          { $gte: ["$date", { $dateFromString: { dateString: isoStart } }] },
          { $lte: ["$date", { $dateFromString: { dateString: isoEnd } }] },
        ],
      };
    })
    .filter(Boolean);

  if (dateConditions.length) {
    pipeline[0].$match.$expr.$and.push({
      $or: dateConditions,
    });
  }

  return pipeline;
}

function getPipelineSuspensionWithinRange(emp, dateRange) {
  const pipeline = getPipelineByEmployees(emp);
  if (!Array.isArray(dateRange) || !dateRange.length) return pipeline;

  if (!pipeline?.[0]?.$match?.$expr?.$and) {
    pipeline[0].$match.$expr.$and = [];
  }

  pipeline[0].$match.$expr.$and.push({
    $eq: ["$status", "active"],
  });

  const rangeConditions = dateRange
    .filter((d) => d && d.startDate && d.endDate)
    .map(({ startDate, endDate }) => {
      const isoStart = parseDateToISO(startDate);
      const isoEnd = parseDateToISO(endDate);

      if (!isoStart || !isoEnd) return null;

      return {
        $and: [
          { $gte: ["$from", { $dateFromString: { dateString: isoStart } }] },
          { $lte: ["$to", { $dateFromString: { dateString: isoEnd } }] },
        ],
      };
    })
    .filter(Boolean);

  if (rangeConditions.length) {
    pipeline[0].$match.$expr.$and.push({
      $or: rangeConditions,
    });
  }

  return pipeline;
}

function parseDateToISO(dateStr) {
  if (!dateStr) return null;

  try {
    const date = new Date(dateStr + " UTC");
    if (isNaN(date.getTime())) {
      console.warn("Invalid date string:", dateStr);
      return null;
    }
    return date.toISOString().split("T")[0];
  } catch (error) {
    console.error("Failed to parse date:", dateStr, error);
    return null;
  }
}

module.exports = {
  getPipelineHolidays,
  getPipelineSuspension,
  getPipelineHolidaysManualTime,
  getPipelineSuspensionManualTime,
  getPipelineByEmployees,
  getPipelineHolidaysWithinRange,
  getPipelineSuspensionWithinRange,
};
